import mainService from 'services/mainService';

export function vesselCategoriesList() {
    return mainService
        .get(`vesselCategories/list`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}
